const sanitizeFilename = (name) => {
  const base = name.normalize("NFKD").replace(/[^\w.\- ]+/g, "").replace(/\s+/g, "_");
  const dot = base.lastIndexOf(".");

  if (dot === -1) return base || "upload";

  const stem = base.slice(0, dot) || "upload";
  const ext = base.slice(dot).toLowerCase();

  return `${stem}${ext}`;
};

const replaceFileInputFiles = (input, files) => {
  const dataTransfer = new DataTransfer();

  files.forEach((file) => dataTransfer.items.add(file));
  input.files = dataTransfer.files;
};

const sanitizeFileInput = (input) => {
  const files = Array.from(input.files || []);
  if (files.length === 0) return;

  const sanitizedFiles = files.map((file) => {
    const safeName = sanitizeFilename(file.name);
    if (safeName === file.name) return file;

    return new File([file], safeName, {
      type: file.type,
      lastModified: file.lastModified,
    });
  });

  const needsReplace = sanitizedFiles.some((file, index) => file !== files[index]);
  if (needsReplace) replaceFileInputFiles(input, sanitizedFiles);
};

document.addEventListener(
  "change",
  (event) => {
    const input = event.target;
    if (input.type !== "file" || input.dataset.skipFilenameSanitize !== undefined) return;

    sanitizeFileInput(input);
  },
  true
);

module.exports = { sanitizeFilename, sanitizeFileInput };
